<template>
<div class="chapter">
<div class="inner_page">
<p class="imgns" id="pg8"><img alt="image" height="690" src="images/pg8.jpg" width="387"/></p>
<p class="capns"><span class="epub-i">One traveled with a different concept of time, in scenery that can be reconstructed only in fragments; the rhythm was that of the horse, the environment that of a Europe with less than one tenth of its present population. Above: Horsemen from the</span> History of the True Cross <span class="epub-i">by Piero della Francesea in San Francesco, Arezzo, and a landscape from the</span> Chronica mundi <span class="epub-i">by Hartmann Schedel (1493).</span></p>
<p class="page-break"> </p>
<p class="pn" id="pt1"><span class="epub-b">Over mountains to inns</span></p>
<p class="pt"><span class="epub-i">Traveling in the Europe of five hundred years ago</span></p>
<p class="img" id="pg9"><img alt="image" height="298" src="images/pg9.jpg" width="200"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?8ff8bcb0